import Vue from "vue";
import Vuex from "vuex";
import PLATFORM from "@/services/platform";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    platforms: [],
    selectedPlatform: null,
  },
  getters: {
    selectedPlatform: (state) =>
      state.platforms.find(
        (platform) => platform.id === state.selectedPlatform
      ),
    platforms: (state) => state.platforms,
  },
  mutations: {
    setPlatforms(state, platforms) {
      state.platforms = platforms;
    },
    selectPlatform(state, platformId) {
      state.selectedPlatform = platformId;
    },
    setParties(state, parties) {
      if (!state.selectedPlatform) return;
      Vue.set(state.parties, state.selectedPlatform, parties);
    },
  },
  actions: {
    async selectPlatform({ commit }, platformId) {
      return commit("selectPlatform", platformId);
    },
    async getAllPlatforms({ commit }) {
      const response = await PLATFORM.getAll();
      commit("setPlatforms", response.platforms);
      return response.platforms;
    },
  },
};
